module.exports = __webpack_public_path__ + "img/rightarrow.5045fa84.svg";